import { ENCODED_EMPTY_EXPERIENCE } from '../constants';

const X_EXPERIENCES_JSON = 'x-experiences-json';

const getExperience = (experiences, name) =>
  experiences ? experiences.find((item) => item.experienceName.includes(name)) : null;

const getDecodedExperiences = (data) => {
  const encodedExperiences = data?.headers?.get(X_EXPERIENCES_JSON) || ENCODED_EMPTY_EXPERIENCE;
  return JSON.parse(atob(encodedExperiences));
};

const isParamTrue = (param) => param === 'true' || param === true;

const getCampaigns = (experiences) => {
  if (!experiences) {
    return [];
  }

  return experiences
    .filter((experience) => !experience.impressionId)
    .map((experience, i) => ({
      ...(experience.impressionId && { id: experience.impressionId }),
      key: experience.experienceName,
      reports: [],
      split: experience.variantLabel,
      parameters: experience.parameters,
      variant_id: i + 1,
    }));
};

const getUniqueCampaigns = (campaigns) => {
  const uniqueValues = new Set();

  return campaigns.filter((el) => {
    const duplicate = uniqueValues.has(el.variant_id);
    uniqueValues.add(el.variant_id);
    return !duplicate;
  });
};

export { getExperience, isParamTrue, getDecodedExperiences, getCampaigns, getUniqueCampaigns };
